<template>
  <div>距离结束 {{ countdown }}</div>
</template>

<script>
export default {
  props: {
    leftMillsec: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      endTime: Date.now() + this.leftMillsec,
      now: Date.now()
    };
  },
  created() {
    this.step();
  },
  methods: {
    step() {
      if (this.endTime - this.now <= 0) {
        return this.$emit('timeend');
      }
      requestAnimationFrame(() => {
        this.now = Date.now();
        requestAnimationFrame(this.step.bind(this));
      });
    },
    fillZero(val) {
      return val >= 10 ? String(val) : `0${val}`;
    }
  },
  computed: {
    countdown() {
      const ms = this.endTime - this.now;
      if (ms <= 0) {
        return '00 ：00 ：00';
      }
      const s = ms / 1000;

      const hh = Math.floor(s / 3600);
      const hhStr = this.fillZero(hh);

      const mmLeft = s % 3600;
      const mm = Math.floor(mmLeft / 60);
      const mmStr = this.fillZero(mm);

      const ss = Math.floor(mmLeft % 60);
      const ssStr = this.fillZero(ss);

      return `${hhStr} ：${mmStr} ：${ssStr}`;
    }
  }
};
</script>
